import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { attribute } from "../ShowModal/ShowModal";

// Models
export interface addServiceFields {
    name?: string,
    description?: string,
    code?: string,
    unit?: string,
    min_area?: string,
    attributes?: attribute[],
    serial_number?:string
}

// Add service state
export interface addSaterialState {
    fields: addServiceFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean,
    serial_number?:string
}

const initialAddSaterialState: addSaterialState = {
    fields: {
        name: "",
        description: "",
        code: "",
        attributes: [],
        min_area:'0',
        unit:"Area",
        serial_number:'0'

    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const addServiceSlice = createSlice({
    name: 'add_service',
    initialState: initialAddSaterialState,
    reducers: {
        init: state => initialAddSaterialState,
        set: (state, { payload }: PayloadAction<addServiceFields>) => {
            state.fields = { ...state.fields, ...payload }
        },
        setAll: (state, { payload }: PayloadAction<addServiceFields>) => {
            state.fields = payload
        },
        setEditId: (state, { payload }: PayloadAction<number>) => {
            state.editId = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
    }
})